export enum ScrollToFormDisplayType {
  Default,
  ShowFormAndBlock,
  SuppressFormAndBlock,
}

export enum DirectionsBlockLayout {
  Narrow,
  Wide,
}

export enum VideoBlockLayout {
  Stacked,
  Split,
}
